// https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/Web-Component-Library?node-id=0%3A1088
import { Button, Menu, MenuButton, MenuList } from '@chakra-ui/react';

import React from 'react';
import { ChevronDownIcon } from '../Icons/Action/CheveronDown';

type DropdownProps = {
  /**
   * Value of Dropdown
   * @type string | undefined
   */
  value?: string | undefined;
  /**
   * Placeholder text
   * @type string
   */
  placeholder?: string;
  /**
   * The icon to render before the menu's label.
   * @type React.ReactElement
   */
  icon?: React.ReactElement;
  /**
   * Width of Dropdown
   * @type string | number | (string) | undefined
   */
  width?: string | number | string | undefined;
  /**
   * Children
   * @type React.ReactNode
   */
  children?: React.ReactNode;
};

export const Dropdown = ({ children, ...props }: DropdownProps) => {
  function getSelectedChild(
    children: React.ReactNode,
  ): React.ReactElement | unknown {
    return React.Children.toArray(children).find(
      (child) =>
        React.isValidElement(child) && child.props.value === props.value,
    );
  }

  function dropdownText(): string {
    let dropdownText = props.placeholder || '';

    if (props.value != null) {
      const selectedItem = getSelectedChild(children);

      if (selectedItem) {
        dropdownText = (
          selectedItem as React.ReactElement
        )?.props?.children.toString();
      } else {
        dropdownText = props.value.toString();
      }
    }
    return dropdownText;
  }

  return (
    <Menu gutter={4} matchWidth={true} flip={false} strategy="fixed">
      <MenuButton
        as={Button}
        minWidth={props.width}
        variant="outline"
        border="1px solid"
        borderColor="tertiary.700"
        borderRadius="small"
        _expanded={{
          color: 'neutral.500',
          border: '2px solid',
          borderColor: 'primary.500',
          bg: 'white.900',
        }}
        _focus={{
          color: 'neutral.500',
          border: '2px solid',
          borderColor: 'primary.500',
          bg: 'white.900',
          boxShadow: 'outline',
        }}
        _hover={{ color: 'neutral.500' }}
        _active={{ bg: 'white.900' }}
        leftIcon={props.icon}
        leftIconSpacing="24px"
        textColor="neutral.500"
        textAlign="left"
        textStyle="body-normal-medium"
        rightIcon={<ChevronDownIcon color={'black'} fontSize={'4xl'} />}
      >
        {dropdownText()}
      </MenuButton>
      <MenuList
        pt={0}
        pb={0}
        maxHeight={'25vh'}
        boxShadow="popOut"
        overflowY={'auto'}
      >
        {children}
      </MenuList>
    </Menu>
  );
};
